import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela, initForm
} from './fornecedorActions';

class FornecedorForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='identificador_cliente'
								component={LabelAndInput}
								label='ID Operação' placeholder='Informe o identificador na operação'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='duns'
								component={LabelAndInput}
								label='DUNS' placeholder='Informe o DUNS'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='contato'
								component={LabelAndInput}
								label='Contato' placeholder='Informe o contato'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='telefone'
								component={LabelAndInput}
								label='Telefone' placeholder='Informe o telefone'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail' placeholder='Informe o email'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='emails_relatorios'
								component={LabelAndInput}
								label='E-mails (envios de relatórios) - separe com vírgula' placeholder='Informe os emails'
								cols='12 12 12 12'
								readOnly={readOnly} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

FornecedorForm = reduxForm({form: 'fornecedorForm', destroyOnUnmount: false})(FornecedorForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('fornecedorForm')(state),
	registro: state.fornecedor.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FornecedorForm);
